import { APICore } from "./apiCore";

// The signed-in admin's bell and notification choices (backend: /api/admin-alerts).
const api = new APICore();
const baseUrl = "/api/admin-alerts";

export interface AlertItem {
  id: number;
  title: string;
  description?: string | null;
  createdAt: string;
  readAt?: string | null;
  event?: string | null;
  /** Admin portal path the notification opens, when it has one. */
  path?: string | null;
}

export interface AlertInbox {
  items: AlertItem[];
  unread: number;
  hasMore: boolean;
}

export interface AlertEventPreference {
  key: string;
  label: string;
  description: string;
  inApp: boolean;
  email: boolean;
}

export interface AlertGroupPreferences {
  key: string;
  label: string;
  permission: string;
  events: AlertEventPreference[];
}

export interface AlertPreferenceInput {
  event: string;
  inApp: boolean;
  email: boolean;
}

function inbox(params?: { limit?: number; before?: number; unread?: boolean }) {
  return api.get(`${baseUrl}/inbox`, params || {});
}

function markRead(id: number) {
  return api.create(`${baseUrl}/inbox/${id}/read`, {});
}

function markAllRead() {
  return api.create(`${baseUrl}/inbox/read-all`, {});
}

function preferences() {
  return api.get(`${baseUrl}/preferences`, {});
}

function savePreferences(preferences: AlertPreferenceInput[]) {
  return api.update(`${baseUrl}/preferences`, { preferences });
}

export { inbox, markRead, markAllRead, preferences, savePreferences };
